<template>
    <div class="main-content">
    <section class="setting-profile-popup mfp-hide popup-save-document" style="z-index: 10">
        <a @click="$router.go(-1)" class="profile-edit-close-btn">
            <img src="/assets/img/close-icon.svg"/>
        </a>
        <div class="setting-profile-wrapper">
            <div class="save-document-form">
                <h2>Setup your Team</h2>
                <p>Choose a Team Name</p>
                <form>
                    <div class="form-group">
                        <label for="TeamName" style="float: left;">Team Name</label>
                        <span>
                            <input type="text" class="form-control" v-model="name" placeholder="Use your company, department or just anything you like" id="TeamName">
                            <div class="field-check teams-check" v-if="name"></div>
                        </span>

                    </div>
                    <div class="form-group">
                        <input type="button" class="btn btn-primary mr-0 mt-3 mx-auto" @click="createTeam()" :disabled="!name || busy" value="create team">
                    </div>
                </form>
            </div>
        </div>
    </section>
    </div>
</template>

<script>
import ApiService from "../../../api/api.service";

export default {
    name: "CreateTeam",
    data: function () {
        return {
            name: '',
            busy: false,
        }
    },
    methods: {
        createTeam() {
            this.busy = true;
            ApiService.setHeader();
            ApiService.post('/api/teams', { name: this.name})
            .then(({data}) => {
                this.busy = false;
                this.$router.push({ name: 'Team Management'}); // team management
            })
            .catch();
        }
    }
}
</script>

<style scoped>
.teams-check {
    position: relative;
    top: -35px;
    display: block;
    right: 35px;
    margin-top: 0px;
}
</style>
